export const SURVEY_QUESTION = {
    NPS: 'QUESTION_NPS',
    FREE: 'QUESTION_FREE',
    SELECTION: 'QUESTION_SELECT',
};

export type SurveyQuestionType = (typeof SURVEY_QUESTION)[keyof typeof SURVEY_QUESTION];

export const SURVEY_TARGET_TYPE = {
    SURVEY_TYPE_AGENT_NORMAL: 'Agent',
    SURVEY_TYPE_COMPANY_NORMAL: 'Company',
    SURVEY_TYPE_BUYER_NORMAL: 'Buyer',
};

export type SurveyTargetType = (typeof SURVEY_TARGET_TYPE)[keyof typeof SURVEY_TARGET_TYPE];

export interface ISurveyQuestion {
    id: number;
    question_type: SurveyQuestionType;
    title: string;
    description: string | null;
    required: boolean;
    answer_text_limit: number | null;
    selection: string[];
}

export interface ISurvey {
    id: number;
    title: string;
    description: string | null;
    questions: number[];
    question_data: ISurveyQuestion[];
}

export const NPS_SCORES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export class Survey implements ISurvey {
    constructor(
        public readonly id: number,
        public readonly title: string,
        public readonly description: string,
        public readonly questions: number[],
        public readonly question_data: ISurveyQuestion[],
    ) {}
}
